import { services } from '../../../mocks/services';

export default function Services() {
  return (
    <section id="services" className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <div className="text-[#2563EB] text-xs sm:text-sm font-bold uppercase tracking-[0.2em] mb-3 md:mb-4">
            OUR SERVICES
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight px-4">
            Complete Home<br />
            Remodeling Solutions
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 md:p-10 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 cursor-pointer group"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center mb-4 sm:mb-5 md:mb-6">
                <i className={`${service.icon} text-3xl sm:text-4xl md:text-5xl text-[#2563EB] group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                {service.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-5 md:mb-6 leading-relaxed">
                {service.description}
              </p>
              <a href="#contact" className="text-[#2563EB] font-semibold text-sm hover:text-[#1D4ED8] transition-colors inline-flex items-center gap-2 cursor-pointer">
                Learn More 
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}